import axios from "axios";
import {
  ALERT_LIST_REQUEST,
  ALERT_LIST_SUCCESS,
  ALERT_LIST_FAIL,
  PROXY,
  DELETE_ALERT_SUCCESS,
  DELETE_ALERT_FAIL,
  OPEN_ALERT_FAIL,
  OPEN_ALERT_SUCCESS,
  VIDEO_LIST_REQUEST,
  VIDEO_LIST_SUCCESS,
  VIDEO_LIST_FAIL,
  DELETE_VIDEO_SUCCESS,
  DELETE_VIDEO_FAIL,
  OPEN_VIDEO_SUCCESS,
  OPEN_VIDEO_FAIL,
} from "../contants/allConstants";

export const getAllAlerts = (token, userId, type) => async (dispatch) => {
  try {
    dispatch({ type: type=="video" ? VIDEO_LIST_REQUEST: ALERT_LIST_REQUEST });

    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        type,// video or alert
      },
    };
    const { data } = await axios.get(`${PROXY}/alert/all`, config);
    if(type=="video"){
      dispatch({
        type:VIDEO_LIST_SUCCESS,
        payload:{ videos: data, userId },
      });
    }else{
      dispatch({
        type: ALERT_LIST_SUCCESS,
        payload:{ alerts: data, userId },
      });
    }
  } catch (error) {
    dispatch({
      type:type=="video" ? VIDEO_LIST_FAIL: ALERT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteAlert = (token, id) => async (dispatch) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const { data } = await axios.delete(`${PROXY}/alert/${id}`, config);
    dispatch({
      type: DELETE_ALERT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: DELETE_ALERT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const openAlerts = (token) => async (dispatch) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    await axios.post(`${PROXY}/alert/open`, {}, config); //empty body
    dispatch({
      type: OPEN_ALERT_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: OPEN_ALERT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const searchAlerts =
  (token, keyword = "", startDate = "", endDate = "", userId, type) =>
  async (dispatch) => {
    try {
      dispatch({ type: ALERT_LIST_REQUEST });
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          keyword,
          startDate,
          endDate,
          type,
        },
      };
      const { data } = await axios.get(`${PROXY}/alert/search`, config);

      dispatch({
        type: ALERT_LIST_SUCCESS,
        payload: { alerts: data, userId },
      });
    } catch (error) {
      dispatch({
        type: ALERT_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };


  export const getManagerAlerts =
  (token, keyword = "", startDate = "", endDate = "", userId) =>
  async (dispatch) => {
    try {
      dispatch({ type: ALERT_LIST_REQUEST });
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: { keyword, startDate, endDate },
      };
      const { data } = await axios.get(`${PROXY}/alert/manager`, config);

      dispatch({
        type: ALERT_LIST_SUCCESS,
        payload: { alerts: data, userId },
      });
    } catch (error) {
      dispatch({
        type: ALERT_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };



  export const getManagerVideos =
  (token, keyword, startDate, endDate,userId) =>
  async (dispatch) => {
    try {
      dispatch({ type: VIDEO_LIST_REQUEST });
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: { keyword, startDate, endDate },
      };
      const { data } = await axios.get(`${PROXY}/video/manager`, config);
      dispatch({
        type: VIDEO_LIST_SUCCESS,
        payload: { videos: data, userId },
      });
    } catch (error) {
      dispatch({
        type: VIDEO_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };



export const deleteVideo = (token, id) => async (dispatch) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const { data } = await axios.delete(`${PROXY}/alert/${id}`, config);
    dispatch({
      type: DELETE_VIDEO_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: DELETE_VIDEO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


export const openVideos = (token) => async (dispatch) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    
    await axios.post(`${PROXY}/alert/open`, {}, config); //empty body
    dispatch({
      type: OPEN_VIDEO_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: OPEN_VIDEO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


export const pinAlert = (token, alert_id, isPinned, callback) => async (dispatch) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${token}` }    };

    const formData = new FormData();
    formData.append("id", alert_id);
    formData.append("isPinned", isPinned);

    await axios.post(`${PROXY}/alert/pin`,{ id:alert_id, isPinned }, config); 
    dispatch({
      type: OPEN_ALERT_SUCCESS,
    });
    callback()
  } catch (error) {
    dispatch({
      type: OPEN_ALERT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};